import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import PageShell from "../components/PageShell";
import { useAuth } from "../context/AuthContext";
import "./AcceptInvite.css";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

function passwordStrength(pw) {
  if (pw.length < 6) return "weak";
  if (pw.length < 10) return "medium";
  return "strong";
}

export default function AcceptInvite() {
  const q = useQuery();
  const token = q.get("token") || "";
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  // Example – later you can fetch this from backend
  const companyName = "Zyft Technologies";
  const inviteExpires = "6 days";

  const strength = passwordStrength(password);

  const submit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token) {
      setError("Invalid or expired invite link.");
      return;
    }

    if (!name.trim() || !password) {
      setError("Please fill all fields.");
      return;
    }

    try {
      setSubmitting(true);
      await axios.post(
        "/api/invites/accept",
        { token, name: name.trim(), password },
        { withCredentials: true }
      );

      setDone(true);
      await refreshUser();
      navigate("/dashboard", { replace: true });
    } catch (e) {
      setError(
        e?.response?.data?.error ||
          "Invite could not be accepted."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <PageShell>
      <div className="acceptWrap">
        <div className="acceptCard">

          {/* Logo */}
          <div className="logoBox">
            Z
          </div>

          {/* Header */}
          <div className="acceptHeader">
            <h1>Join {companyName}</h1>
            <p>This invite expires in {inviteExpires}</p>
          </div>

          {error && <div className="alert error">{error}</div>}
          {done && (
            <div className="alert success">
              Account created — redirecting…
            </div>
          )}

          <form onSubmit={submit} className="acceptForm">
            <div>
              <label>Full name</label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
                disabled={submitting}
              />
            </div>

            <div>
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Create a password"
                disabled={submitting}
              />

              <div className={`pwStrength ${strength}`}>
                <span />
              </div>
            </div>

            <button disabled={submitting}>
              {submitting ? "Creating account…" : "Create account"}
            </button>
          </form>

          <div className="acceptFooter">
            Already have an account? <a href="/login">Sign in</a>
          </div>
        </div>
      </div>
    </PageShell>
  );
}

